import React from 'react';
import { Outlet } from 'react-router-dom';

const LoggedInNonHeaderLayout: React.FC = () => {
  return (
    <div className="flex flex-col h-screen">
      <main className="flex-grow overflow-auto bg-zinc-50">
        <Outlet />
      </main>
    </div>
  );
};

export default LoggedInNonHeaderLayout;